import { createContext } from 'react';
import KickImage from 'Reuseables/KickImage';

export const SidebarMenuContext = createContext({
  menuShow: false,
  onMenuDetail: false,
  menuDetailCategory: '',
  toggleMenuShow: (isShow: boolean) => {},
  toggleMenuDetail: (isMenuDetail: boolean) => {},
  setMenuDetailCategory: (category: string) => {},
});
